"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMeasureClass = void 0;
var format_1 = require("./format");
function createMeasureClass(num) {
    function getFormatter(formatter) {
        if (formatter === undefined) {
            return {
                formatValue: num.format,
                formatUnit: format_1.defaultFormatUnit,
            };
        }
        else {
            return {
                formatValue: formatter.formatValue || num.format,
                formatUnit: formatter.formatUnit || format_1.defaultFormatUnit,
            };
        }
    }
    var Measure = /** @class */ (function () {
        function Measure(value, unit, unitSystem, symbol) {
            this.value = value;
            this.unit = unit;
            this.unitSystem = unitSystem;
            this.symbol = symbol;
        }
        // Arithmetic
        Measure.prototype.plus = function (other) {
            return new Measure(num.add(this.value, other.value), this.unit, this.unitSystem);
        };
        Measure.prototype.minus = function (other) {
            return new Measure(num.sub(this.value, other.value), this.unit, this.unitSystem);
        };
        Measure.prototype.negate = function () {
            return new Measure(num.neg(this.value), this.unit, this.unitSystem);
        };
        Measure.prototype.scale = function (value) {
            return new Measure(num.mult(this.value, value), this.unit, this.unitSystem);
        };
        Measure.prototype.times = function (other) {
            return new Measure(num.mult(this.value, other.value), this.unitSystem.multiply(this.unit, other.unit), this.unitSystem);
        };
        Measure.prototype.over = function (other) {
            return new Measure(num.div(this.value, other.value), this.unitSystem.divide(this.unit, other.unit), this.unitSystem);
        };
        Measure.prototype.per = function (other) {
            return this.over(other);
        };
        Measure.prototype.div = function (other) {
            return this.over(other);
        };
        Measure.prototype.squared = function () {
            return this.times(this);
        };
        Measure.prototype.cubed = function () {
            return this.squared().times(this);
        };
        Measure.prototype.inverse = function () {
            return this.reciprocal();
        };
        Measure.prototype.reciprocal = function () {
            return new Measure(num.reciprocal(this.value), this.unitSystem.reciprocal(this.unit), this.unitSystem);
        };
        Measure.prototype.unsafeMap = function (valueMap, unitMap) {
            var _a;
            var newUnit = (_a = unitMap === null || unitMap === void 0 ? void 0 : unitMap(this.unit)) !== null && _a !== void 0 ? _a : this.unit;
            return new Measure(valueMap(this.value), newUnit, this.unitSystem);
        };
        // Comparisons
        Measure.prototype.compare = function (other) {
            return num.compare(this.value, other.value);
        };
        Measure.prototype.lt = function (other) {
            return this.compare(other) < 0;
        };
        Measure.prototype.lte = function (other) {
            return this.compare(other) <= 0;
        };
        Measure.prototype.eq = function (other) {
            return this.compare(other) === 0;
        };
        Measure.prototype.neq = function (other) {
            return this.compare(other) !== 0;
        };
        Measure.prototype.gte = function (other) {
            return this.compare(other) >= 0;
        };
        Measure.prototype.gt = function (other) {
            return this.compare(other) > 0;
        };
        // Formatting
        Measure.prototype.toString = function (formatter) {
            var _a = getFormatter(formatter), formatValue = _a.formatValue, formatUnit = _a.formatUnit;
            return "".concat(formatValue(this.value), " ").concat(formatUnit(this.unit, this.unitSystem)).trimRight();
        };
        Measure.prototype.in = function (unit, formatter) {
            if (unit.symbol === undefined) {
                return this.toString(formatter);
            }
            var formatValue = getFormatter(formatter).formatValue;
            var value = formatValue(num.div(this.value, unit.value));
            return "".concat(value, " ").concat(unit.symbol);
        };
        Measure.prototype.valueIn = function (unit) {
            return num.div(this.value, unit.value);
        };
        Measure.prototype.withSymbol = function (symbol) {
            return new Measure(this.value, this.unit, this.unitSystem, symbol);
        };
        Measure.prototype.clone = function () {
            return new Measure(this.value, this.unit, this.unitSystem);
        };
        return Measure;
    }());
    return {
        createMeasure: function (value, unit, unitSystem, symbol) { return new Measure(value, unit, unitSystem, symbol); },
        isMeasure: function (value) { return value instanceof Measure; },
    };
}
exports.createMeasureClass = createMeasureClass;
//# sourceMappingURL=genericMeasureClass.js.map